module.exports = __webpack_public_path__ + "img/c2.815b6a5f.png";